"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _v9ProviderProfile = require("./v9-provider-profile");
var _searchWidgetV = require("./search-widget-v2");
const FALLBACK_KEYS = {
  // button color overrides for custom flat/ghost buttons
  color_button_contrast: 'color_button',
  color_button_contrast_text: 'color_button_contrast',
  color_button_contrast_hover: 'color_button_contrast',
  color_button_contrast_hover_text: 'color_background',
  color_button_active: 'color_button',
  // button color overrides for tertiary/quaternary modes
  color_button_tertiary: 'color_button',
  color_button_tertiary_hover: 'color_button_hover',
  color_button_tertiary_disabled: 'color_button_disabled',
  color_button_quaternary: 'color_button',
  color_button_quaternary_hover: 'color_button_hover',
  color_button_quaternary_disabled: 'color_button_disabled',
  // button color overrides for appt info widget
  appt_info_color_button: 'color_button_contrast',
  appt_info_color_button_text: 'appt_info_color_button',
  appt_info_color_button_active: 'appt_info_color_button',
  appt_info_color_button_active_text: 'color_button_contrast_hover_text',
  appt_info_color_button_hover: 'color_button_hover',
  appt_info_color_button_hover_text: 'color_button_contrast_hover_text',
  // V9 Provider Profile customer config fallbacks
  ..._v9ProviderProfile.V9_PROVIDER_PROFILE_FALLBACKS,
  // fallback keys for styles from search widget admin
  ..._searchWidgetV.SEARCH_WIDGET_V2_FALLBACKS
};
var _default = exports.default = FALLBACK_KEYS;